<script>
import { Bar, mixins } from "vue-chartjs";
import colormap from "colormap";

export default {
    name: "TemperatureMatrix",
    extends: [Bar],
    mixins: [Bar, mixins.reactiveData],
    //====================================================================
    props: {
        // chartOptions: {}
        matrixData: {
            type: Object,
            require: true,
        },
        matrixRange: {
            type: Object,
            require: true,
        },
        matrixType: {
            type: String,
            require: true,
        },
    },
    //====================================================================
    data() {
        return {
            mapHeight: 20,
            mapWidth: 24 * 2,
            colors: null,
            colorRangeMax: 30,
            colorRangeMin: 20,
            chartData: {
                datasets: {},
            },
            options: {
                responsive: true,
                maintainAspectRatio: false, // アスペクト比を維持しない
                legend: { display: false, position: "bottom" },
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                            // ticks: { min: 0, display: true },
                            // time: { displayFormats: { hour: "D日H時", day: "D日H時", month: "D日H時" } },
                            ticks: { minRotation: 0, maxRotation: 0, maxTicksLimit: 4, fontColor: "#000" },
                            gridLines: { drawOnChartArea: true, color: "#dddddd" },
                            // gridLines: { color: "#FFFFFF" },
                        },
                    ],
                    yAxes: [
                        {
                            gridLines: { color: "#FFFFFF", zeroLineWidth: 0 },
                            stacked: true,
                            ticks: { min: 0, stepSize: 1, reverse: true, display: true },
                        },
                    ],
                },
                tooltips: {
                    enabled: false,
                },
                // tooltips: {
                //     callbacks: {
                //         label: function (tooltipItem) {
                //             const idx = tooltipItem.dataIndex;
                //             const val = tooltipItem.dataset.yVals[idx];
                //             return val;
                //         },
                //     },
                // },
            },
        };
    },
    //====================================================================
    created: function () {
        this.colors = colormap({
            colormap: "jet",
            nshades: (this.colorRangeMax - this.colorRangeMin) * 10, // 0.1度単位で色を変えたいのでカラー数は10倍
            format: "hex",
            alpha: 1,
        });
    },
    //====================================================================
    async mounted() {
        this.colorRangeMin = this.matrixRange.min;
        this.colorRangeMax = this.matrixRange.max;
        this.colors = this.generateColorMap();
        const { labels, datasets } = await this.generateDatasets();
        this.chartData.labels = labels;
        this.chartData.datasets = datasets;
        this.renderChart(this.chartData, this.options);
    },
    //====================================================================
    watch: {
        matrixData: async function () {
            const { labels, datasets } = await this.generateDatasets();
            this.chartData.labels = labels;
            this.chartData.datasets = datasets;
            this.renderChart(this.chartData, this.options);
        },
        matrixRange: async function () {
            this.colorRangeMin = this.matrixRange.min;
            this.colorRangeMax = this.matrixRange.max;
            this.colors = this.generateColorMap();
            const { labels, datasets } = await this.generateDatasets();
            this.chartData.labels = labels;
            this.chartData.datasets = datasets;
            this.renderChart(this.chartData, this.options);
        },
    },
    //====================================================================
    methods: {
        //-------------------------------------------
        generateColorMap() {
            return colormap({
                colormap: this.matrixType,
                nshades: (this.colorRangeMax - this.colorRangeMin) * 10, // 0.1度単位で色を変えたいのでカラー数は10倍
                format: "hex",
                alpha: 1,
            });
        },
        //-------------------------------------------
        generateDatasets() {
            const datasets = [];
            //-----------------------------------
            // とりあえず、水深別XYデータのみに
            let DS = [];
            const xyDataAry = [];
            if (this.matrixData && this.matrixData.datasets) DS = this.matrixData.datasets;
            for (let i in DS) {
                const DT = DS[i].data;
                xyDataAry.push(DT);
            }
            //-----------------------------------
            let sdate = null;
            let edate = null;
            for (let i in xyDataAry) {
                for (let j in xyDataAry[i]) {
                    const xy = xyDataAry[i][j];
                    const x = xy.x;
                    if (sdate == null || sdate > x) sdate = x;
                    if (edate == null || edate < x) edate = x;
                }
            }
            if (sdate && edate) {
                sdate = this.$moment(sdate);
                edate = this.$moment(edate);
                this.mapWidth = edate.diff(sdate, "hours");
            }
            //-----------------------------------
            const labels = new Array(this.mapWidth).fill("");
            for (let i in xyDataAry) {
                for (let j in xyDataAry[i]) {
                    const xy = xyDataAry[i][j];
                    const x = xy.x;
                    const xdate = this.$moment(x);
                    const aryIdx = xdate.diff(sdate, "hours");
                    labels[aryIdx] = this.$moment(x).format("D日H時");
                }
            }
            //-----------------------------------
            const colorRange = (this.colorRangeMax - this.colorRangeMin) * 10 - 1;
            for (let i in xyDataAry) {
                const colorAry = new Array(this.mapWidth).fill("#FFFFFF");
                for (let j in xyDataAry[i]) {
                    const xy = xyDataAry[i][j];
                    const x = xy.x;
                    const y = xy.y;
                    const xdate = this.$moment(x);
                    const aryIdx = xdate.diff(sdate, "hours");

                    let colorIndex = Math.floor((y - this.colorRangeMin) * 10); // 0.1度単位で色を変えるので10倍
                    if (colorIndex < 0) colorIndex = 0;
                    if (colorIndex > colorRange) colorIndex = colorRange;
                    // colorIndex = colorRange - colorIndex; //色逆転
                    let color = this.colors[colorIndex];
                    if (!y) color = "#FFFFFF";
                    //colorAry.push(color);
                    colorAry[aryIdx] = color;
                }
                datasets.push({
                    data: new Array(this.mapWidth).fill(1),
                    borderWidth: 0.2,
                    borderColor: "#FFFFFF",
                    backgroundColor: colorAry,
                    barPercentage: 0.99,
                    categoryPercentage: 0.99,
                });
            }
            //-----------------------------------
            return { labels, datasets };
        },
        //--------------------------------
    },
    //====================================================================
};
</script>
